import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import { FaSearch, FaLock, FaLockOpen, FaUndo } from "react-icons/fa";
import axios from "axios";
import toast from "react-hot-toast";
import { confirmAlert } from "react-confirm-alert";

import { gbState } from "../../../components/shared/GlobalState";

const ListClosureHistoryChild = () => {
  const navigate = useNavigate();
  const [{ errorLogApi, user }] = useAtom(gbState);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState([]);

  const handleDelete = (id) => {
    confirmAlert({
      title: "",
      message: "Are you sure to revoke this closure ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteRecord(id),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const deleteRecord = (id) => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/closure/revoke/${id}`,
      headers: { Authorization: `Bearer ${userToken}` },
    };
    axios(config)
      .then((response) => {
        // alert(JSON.stringify(response));
        getDataFromServer();
      })
      .catch((err) => {
        errorLogApi(err, "ListClosureHistoryChild", "/closure/revoke");
      });
  };

  const getDataFromServer = () => {
    let userToken = localStorage.getItem("token");

    let urlLink = `${process.env.REACT_APP_API_URL}/closure/church`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data.users));
        const oldData = response?.data;
        const updatedData = oldData.map((data) => {
          return {
            ...data,
            id: data?._id,
            financial_year: data?.financial_year,
            closure_month: JSON.parse(data?.closure_month).label,
            closure_date: data?.closure_date,
            church_name: data?.church_id?.church_name,
            church_code: data?.church_id?.church_code,
            closed_by: `${data?.closed_by?.first_name} ${data?.closed_by?.last_name}`,
            closure_status: data?.closure_status,
          };
        });
        setData(updatedData);
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  };

  useEffect(() => {
    getDataFromServer();
  }, []);

  const filteredData = useMemo(() => {
    return data.filter((item) =>
      Object.values(item).some((value) =>
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [data, searchTerm]);

  const paginatedData = useMemo(() => {
    const startIndex = page * rowsPerPage;
    return filteredData.slice(startIndex, startIndex + rowsPerPage);
  }, [filteredData, page, rowsPerPage]);

  return (
    <div className="w-full px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Closure History</h2>
      </div>

      <div className="mb-4">
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search closure history..."
          InputProps={{
            startAdornment: <FaSearch className="mr-2 text-gray-400" />,
          }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Action</TableCell>
              <TableCell>Financial Year</TableCell>
              <TableCell>Month</TableCell>
              <TableCell>Church Name</TableCell>
              <TableCell>Code</TableCell>
              <TableCell>Closed By</TableCell>
              <TableCell>Closure Status</TableCell>
              <TableCell>Closure Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map((row) => (
              <TableRow key={row.id}>
                <TableCell>
                  <Tooltip title="Revoke Closure">
                    <IconButton
                      size="small"
                      onClick={() => handleDelete(row.id)}
                    >
                      <FaUndo className="text-red-600" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
                <TableCell>{row.financial_year}</TableCell>
                <TableCell>{row.closure_month}</TableCell>
                <TableCell>{row.church_name}</TableCell>
                <TableCell>{row.church_code}</TableCell>
                <TableCell>{row.closed_by}</TableCell>
                <TableCell>
                  {row.closure_status ? (
                    <FaLock className="text-red-600" />
                  ) : (
                    <FaLockOpen className="text-green-600" />
                  )}
                </TableCell>
                <TableCell>{row.closure_date?.slice(0, 10)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination controls */}
      <div className="flex items-center justify-between mt-4">
        <div>
          <span>Rows per page: </span>
          <select
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
          >
            {[5, 10, 25, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </div>
        <div>
          <Button
            disabled={page === 0}
            onClick={() => setPage((prev) => prev - 1)}
          >
            Previous
          </Button>
          <Button
            disabled={paginatedData.length < rowsPerPage}
            onClick={() => setPage((prev) => prev + 1)}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ListClosureHistoryChild;
